import { memo } from 'react';

import { Builder, withChildren } from '@builder.io/react';
import dynamic from 'next/dynamic';

import { uiImages } from '@/react/components/content/registry/data';
import { defaultContainer } from '../../registry/data/parts/defaultBlock';

/**
 * Register the ContentExperience component.
 */
const register = (): void => {
  const component = memo(dynamic(() => import('./index')));
  const componentWithChildren = withChildren(component);

  Builder.registerComponent(componentWithChildren, {
    name: 'ContentExperience',
    friendlyName: 'DY Content Experience',
    static: true,
    canHaveChildren: true,
    inputs: [
      {
        name: 'experienceID',
        type: 'string',
        required: true
      },
      {
        name: 'decisions',
        type: 'list',
        broadcast: true,
        subFields: [
          {
            name: 'decisionID',
            type: 'string',
            required: true
          },
          {
            name: 'blocks',
            type: 'array',
            hideFromUI: true,
            defaultValue: defaultContainer
          }
        ]
      },
      {
        name: 'fallbackBlocks',
        type: 'array',
        hideFromUI: true,
        defaultValue: defaultContainer
      }
    ],
    defaultChildren: [],
    image: uiImages.sectionImage
  });
};

export default register;
